<script setup lang="ts">
import {Contest} from "@/contest/interfaces";
import {Dialog, DialogScrollContent} from "@/core/components/ui/dialog";
import ContestComponent from "@/contest/components/Contest.vue";

const props = defineProps<{
    contest: Contest | null;
}>();

const open = defineModel<boolean>("open", {required: true});
const emit = defineEmits(['on-refresh']);
</script>

<template>
  <Dialog v-model:open="open">
    <DialogScrollContent class="min-w-[80%] max-h-[85vh] overflow-y-auto">
      <ContestComponent
        v-if="props.contest"
        :contest="props.contest"
        :has-action="true"
        :should-load="open"
        @update:contest="emit('on-refresh')"
      />
    </DialogScrollContent>
  </Dialog>
</template>


